import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Wrapper } from './styled'

export const Hero = () => {
  const blockId = CMS_BLOCK.PPL_HERO
  const heroContent = useCmsBlock({
    id: blockId
  })

  if (!heroContent.content) return null

  return (
    <Wrapper
      dangerouslySetInnerHTML={{
        __html: heroContent.content
      }}
    />
  )
}
